import styled from "styled-components";
import Flex from "app/components/Flex";

export const SwitchWrapper = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
